import { render, staticRenderFns } from "./PluginList.vue?vue&type=template&id=c1f0c6b2&"
import script from "./PluginList.vue?vue&type=script&lang=js&"
export * from "./PluginList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports